import PropTypes from 'prop-types';

export const blogCardPropTypes = {
    image: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    author: PropTypes.shape({
        name: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired
    }).isRequired,
    tags: PropTypes.arrayOf(PropTypes.string).isRequired,
    date: PropTypes.string.isRequired,
    detailsLink: PropTypes.string,
    className: PropTypes.string
};

export const categoryItemPropTypes = {
    category: PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired
    }).isRequired,
    isSelected: PropTypes.bool,
    onSelect: PropTypes.func.isRequired
};
